import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'utils/classNames';
import { getPaymentPeriod } from 'utils/formatAmount';

import styles from './subscription-card.scss';

export default function SubscriptionCard({ id, title, cost, once_per_days, onClick, selected, paused_at, status }) {
    function handleClick() {
        if (onClick) {
            onClick(id);
        }
    }

    const getDescriptionText = () => {
        switch (status) {
            case 'PAUSED':
                return 'Приостановлена';
            case 'CANCELLED_BY_CLIENT':
                return 'Отменена клиентом';
            case 'CANCELLED_BY_MANAGER':
                return 'Отменена менеджером';
            case 'ENDED':
                return 'Закончилась';
            case 'ACTIVE':
                return `${cost} ₽ / ${getPaymentPeriod(once_per_days)}`;
            default:
                return 'Отменена';
        }
    };

    const getWrapperClass = () =>
        classNames(styles.wrapper, {
            [styles.selected]: selected,
            [styles.paused]: status === 'PAUSED',
            [styles.cancelled]: ['CANCELLED_BY_CLIENT', 'CANCELLED_BY_MANAGER', 'ENDED'].includes(status),
        });

    return (
        <div className={getWrapperClass()} onClick={handleClick}>
            <h2>{title}</h2>
            <span>{getDescriptionText()}</span>
        </div>
    );
}

SubscriptionCard.propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.oneOf(['ACTIVE', 'PAUSED', 'CANCELLED_BY_CLIENT', 'CANCELLED_BY_MANAGER', 'ENDED']),
    once_per_days: PropTypes.number,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    paused_at: PropTypes.string,
};
